export var MultiStepRouteType;
(function (MultiStepRouteType) {
    MultiStepRouteType[MultiStepRouteType["PERSONAL"] = 0] = "PERSONAL";
    MultiStepRouteType[MultiStepRouteType["ADDITIONAL"] = 1] = "ADDITIONAL";
    MultiStepRouteType[MultiStepRouteType["PAYMENT"] = 2] = "PAYMENT";
    MultiStepRouteType[MultiStepRouteType["CLAIM"] = 3] = "CLAIM";
    MultiStepRouteType[MultiStepRouteType["EXIT_SURVEY"] = 4] = "EXIT_SURVEY";
    MultiStepRouteType[MultiStepRouteType["INTRO"] = 5] = "INTRO";
})(MultiStepRouteType || (MultiStepRouteType = {}));
//# sourceMappingURL=route.js.map